import {
  csRegionTotalsShiftTypeNames,
  csRegionTotalsShiftTypes,
} from '@lp/features/Scheduler/SchedulerClinicalSpecialists/constants';
import { ResourceShiftTotalsMap } from '@lp/features/Scheduler/types';
import { CSShiftOptionType } from '@lp/features/Scheduler/SchedulerClinicalSpecialists/types';
import { ResourceShiftTotalsTable } from '@lp/features/Scheduler/components';
import { CSResource } from '@/api/apis/resources/schedule';

type CSResourceShiftTotalsTableProps = {
  userRows: CSResource[];
  shiftTotalsMap?: ResourceShiftTotalsMap<CSShiftOptionType>;
};

export const CSResourceShiftTotalsTable = ({ userRows, shiftTotalsMap }: CSResourceShiftTotalsTableProps) => {
  return (
    <ResourceShiftTotalsTable
      userRows={userRows}
      shiftTotalsMap={shiftTotalsMap}
      shiftTotalsTypeList={csRegionTotalsShiftTypes}
      shiftTotalsTypeNames={csRegionTotalsShiftTypeNames}
    />
  );
};
